export const createImage = (url: string) =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export const getRadianAngle = (degreeValue: number) => (degreeValue * Math.PI) / 180;

export const rotateSize = (width: number, height: number, rotation: number) => {
  const rotRad = getRadianAngle(rotation);

  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
};

export async function getCroppedImg(imageSrc: string) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  }
  ctx.imageSmoothingQuality = 'high';
  const rotRad = getRadianAngle(0);

  // calculate bounding box of the rotated image
  // @ts-ignore
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(image.width, image.height, 0);

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  // ctx.translate(bBoxWidth / 2, bBoxHeight / 2);

  ctx.translate(bBoxWidth / 1.7, bBoxHeight / 1.7);
  ctx.rotate(rotRad);
  ctx.scale(1, 1); // @ts-ignore
  // ctx.translate(-image.width / 2, -image.height / 2);
  ctx.translate(-image.width / 1.7, -image.height / 1.7);

  // const x = Math.floor(bBoxWidth / 4);
  // const y = Math.floor(bBoxHeight / 4);
  const x = Math.floor(bBoxWidth / 5);
  const y = Math.floor(bBoxHeight / 5);

  // draw rotated image
  // @ts-ignore
  ctx.drawImage(image, 0, 0);

  // croppedAreaPixels values are bounding box relative
  // extract the cropped image using these values
  // const data = ctx.getImageData(x, y, bBoxWidth / 2, bBoxHeight / 2);
  const data = ctx.getImageData(x, y, bBoxWidth / 1.7, bBoxHeight / 1.7);

  // set canvas width to final desired crop size - this will clear existing context
  // canvas.width = bBoxWidth / 2;
  // canvas.height = bBoxHeight / 2;

  canvas.width = bBoxWidth / 1.7;
  canvas.height = bBoxHeight / 1.7;

  // paste generated rotate image at the top left corner
  ctx.putImageData(data, 0, 0);

  return canvas.toDataURL('image/jpeg', 1);
}

export async function getRotatedImage(imageSrc: string, rotation = 90) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  }
  ctx.imageSmoothingQuality = 'high';

  const orientationChanged = rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270;
  if (orientationChanged) {
    // @ts-ignore
    canvas.width = image.height; // @ts-ignore
    canvas.height = image.width;
  } else {
    // @ts-ignore
    canvas.width = image.width; // @ts-ignore
    canvas.height = image.height;
  }

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((rotation * Math.PI) / 180); // @ts-ignore
  ctx.drawImage(image, -image.width / 2, -image.height / 2);

  return canvas.toDataURL('image/jpeg', 1);
}
